const loadingLabel = "Chargement";
const frLU = {
  loadingLabel
};
export {
  frLU as default,
  loadingLabel
};
